import React, { useState, useRef } from 'react';
import Cookies from "js-cookie";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getGameStatus } from '../gameSlice';
import api from '../../../api';
import { useEffect } from "react";
import useReadCookies from "../../hooks/useReadCookies";
import { isEnglishLanguage } from '../../../utils/index';

function MainQuestion({ setShowImageViewer, missionData, isMissionEnd, setShowMainQuestionEnd, setIsMissionSuccess, setIsMissionEnd, setShowMissionOnly })
{
  const [isAnswersLocked, setIsAnswersLocked] = useState(true);
  const { t, i18n } = useTranslation();
  const isEnglish = isEnglishLanguage(i18n);
  const dispatch = useDispatch();

  let { cookiePlayerId, cookieGroupId } = useReadCookies();

  const [answer, setAnswer] = useState(null);
  const [interactionStarted, setInteractionStarted] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipTimer, setTooltipTimer] = useState(false);
  let toolTipTimer = null;
  let introTimer = null;

  const players = useSelector((state) => state.game.players);
  const playerCount = useSelector((state) => state.game.playerCount);

  useEffect(() => {
    if(!toolTipTimer){
      const toolTipTimer = setTimeout(() => {
        setShowTooltip(true);
      }, 5000);
    }
  }, []);

  useEffect(() => {
    if(missionData && missionData.main_question_unlocked){
      setIsAnswersLocked(false);
    }
  }, [missionData]);

  const getTitle = () => {
    if(isEnglish){
      return missionData.main_question.title_en;
    }else{
      return missionData.main_question.title_nl;
    }
  }

  const getQuestion = () => {
    if(missionData.grade === 1){
      if(isEnglish){
        return missionData.main_question.description_havo_en;
    }else{
        return missionData.main_question.description_havo_nl;
    }
    }else{
      if(isEnglish){
        return missionData.main_question.description_vmbo_en;
    }else{
        return missionData.main_question.description_vmbo_nl;
    }
    }
  }

  const getAnswers = (answer) => {
    if(isEnglish){
      switch(answer){
        case 'A':
          return missionData.main_question.answer_a_en;
        case 'B':
          return missionData.main_question.answer_b_en;
        case 'C':
          return missionData.main_question.answer_c_en;
        case 'D':
          return missionData.main_question.answer_d_en;
        default:
          return '';
      }
    }else{
      switch(answer){
        case 'A':
          return missionData.main_question.answer_a_nl;
        case 'B':
          return missionData.main_question.answer_b_nl;
        case 'C':
          return missionData.main_question.answer_c_nl;
        case 'D':
          return missionData.main_question.answer_d_nl;
        default:
          return '';
      }
    }
  }

  const otherPlayerName = players.reduce((filtered, player) => {
    if(player.secret !== cookiePlayerId){
      filtered.push(player.name);
    }
    return filtered;
  }, []);

  const handleSetAnser = (selectedAnswer) => {
    if (!isAnswersLocked) {
      if(selectedAnswer === answer){
        setAnswer(null);
      }else {
        setAnswer(selectedAnswer);
      }
      setInteractionStarted(true);
    }
  }

  const handleConfirmAnswer = () => {
    if(missionData.main_question.correct_answer === answer){
      setIsMissionSuccess(true);
    }else{
      setIsMissionSuccess(false);
    }
    setIsMissionEnd(true);
    setShowMissionOnly(true);
    setShowMainQuestionEnd(true);
    
    setTimeout(() => {
      api.completeMission(cookieGroupId, missionData.mission_number, answer).then((response) => {
        if(response.status === 200){
          dispatch(getGameStatus(cookieGroupId));
        }
      });
    }, 2000);
  }

  return (
    <div className={`main-question-wrapper ${isMissionEnd ? 'missionEnded' : ''}`}>
      <div className="scrollElement">
        <div  className="mainMission screenOrnament variant1">
          <div className={`question ${isAnswersLocked ? '' : 'answersUnLocked'}`}>
            <div className="questionTitle">
              { getTitle() }
            </div>
            <div className="questionDetails">
              <p>{ getQuestion() }</p>
            </div>
            <div className={`mainMissionTip ${isAnswersLocked ? 'show' : 'hidden'}`}>
              <div className="speechBalloonSmall">
                {playerCount === 3 && <p>{t("student.main_question.help", otherPlayerName)}</p>}
                {playerCount === 4 && <p>{t("student.main_question.help_extra", otherPlayerName)}</p>}
              </div>
            </div>
          </div>
          <div className={`missionAnswers ${isAnswersLocked ? 'locked' : 'unlocked'} ${interactionStarted ? 'interaction-started' : ''} ${answer === 'A' || answer === 'B' || answer === 'C' || answer === 'D' ? 'selection-active' : ''}`}>
            <div className={`answerButton top-left ${answer === 'A' ? 'selected' : ''}`} onClick={() => { handleSetAnser('A')}}>
              { getAnswers('A') }
              <div className='selectionIndicatorContainer'>
                <div className='indicator'></div>
              </div>
            </div>
            <div className={`answerButton top-right ${answer === 'B' ? 'selected' : ''}`} onClick={() => { handleSetAnser('B')}}>
              { getAnswers('B') }
              <div className='selectionIndicatorContainer'>
                <div className='indicator'></div>
              </div>
            </div>
            <div className={`answerButton bottom-left ${answer === 'C' ? 'selected' : ''}`} onClick={() => { handleSetAnser('C')}}>
              { getAnswers('C') }
              <div className='selectionIndicatorContainer'>
                <div className='indicator'></div>
              </div>
            </div>
            <div className={`answerButton bottom-right ${answer === 'D' ? 'selected' : ''}`} onClick={() => { handleSetAnser('D')}}>
              { getAnswers('D') }
              <div className='selectionIndicatorContainer'>
                <div className='indicator'></div>
              </div>
            </div>
            <div className={`lockBandContainer ${isAnswersLocked ? '' : 'unlocked'}`}>
              <div className='lockBandLeft'></div>
              <div className='lockBandRight'></div>
              <div className={`lock ${isAnswersLocked ? '' : 'unlocked'}`}></div>
            </div>
          </div>
          <div className="mainMissionBackground"></div>
        </div>
        
      </div>
      <div className="navigationWrapper">
        {answer === null &&
        <div className={`bookDrawer screenOrnament variant3 ${interactionStarted ? 'normalAnimInTiming' : ''}`}>
          <div className="bookButton" onClick={e => { clearTimeout(toolTipTimer); setTimeout(() => {setShowTooltip(false);},5000); setShowImageViewer(true)}}>
            <div className="surfaceFX">
              <div className="effectLayer"></div>
            </div>
            <div className="iconBook"></div>
            <div className="arrowUp"></div>
            <div className='caption'>Open Boek</div>
          </div>
        </div>
        }
        {answer !== null &&
        <div className='navigationDrawer variant4 enableInAnimation'>
          <button className='submitButton enableInAnimation' onClick={() => { handleConfirmAnswer(); }}>
            <span className='caption'>{t("student.main_question.submit_button")}</span>
          </button>
        </div>  
        }
      </div>
    </div>
  )
}

export default MainQuestion;
